import  {getRequest,postRequest,post,postVideoRequest}  from "@/utils/axios";
//-------------------首页---------------------
//学习会员-手机号验证码登录发送验证码
export const getCode = data => postRequest(`/customer/rxMediatorTrainMember/mediatorTrainMemberLoginCode`, data)
//手机号+验证码登录
export const studyMemberLogin = data => postRequest(`/customer/rxMediatorTrainMember/mediatorTrainMemberLogin`,data)
// 获取调解员培训视频-课题列表（包含课程）
export const mediatorTrainSubjectList = data => postRequest(`/customer/rxMediatorTrainMember/mediatorTrainSubjectList`, data)
//获取调解员培训视频-分页列表
// export const getMediatorTrainPage = data => postRequest(`/customer/rxMediatorTrainMember/mediatorTrainPage`, data)
// 获取调解员培训视频详细（包含url）
export const getVideoUrlsByVideoId = data => postVideoRequest(`/customer/rxMediatorTrainMember/mediatorTrainInfo`, data)
//获取当前视频播放进度（秒数）
export const getVideoPlayInfo = data => postRequest(`/customer/rxMediatorTrainMember/getVideoPlayInfo`, data)
//存储当前视频播放进度（秒数）
export const saveVideoPlayInfo = data => postVideoRequest(`/customer/rxMediatorTrainMember/saveVideoPlayInfo`, data)
// 当前学员课程列表，学习进度
export const getCurrentMemberStudyInfo = data => postVideoRequest(`/customer/rxMediatorTrainMember/currentMemberStudyInfo`, data)

